<template>
  <div class="home">
    <TableList v-show="listView" @newTable="onClickNewFromList" @editTable="onClickEditFromList"  :scroll="corY" ref="refreshList"/>
    <TableForm v-show="formView" :table="table" @backClicked="onBackChild" @backSaveChild="onBackSaveChild" @backClickID ="onBackParentID"/>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import TableList from '@/components/table/TableList.vue'
import TableForm from '@/components/table/TableForm.vue'
import { tableUrl, getHeader } from '../config'
import { mapState } from 'vuex'

export default {
  name: 'Table',
  components: {
    TableList,
    TableForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      table: {
        id: null,
        table_no: null,
        alias: null,
        notes: null,
        asset_no: null,
        asset: null,
        company_no: null,
        expenses: [{
          id: null,
          table_no: null,
          product_no: null,
          qty: '0',
          uom_id: null,
          price: '0',
          subtotal: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          notes: null,
          company_no: null,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.table = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.table = {
        id: null,
        table_no: null,
        alias: null,
        notes: null,
        asset_no: null,
        asset: null,
        company_no: this.authUser.company_no,
        expenses: []
      }
    },
    async onBackParentID (id) {
      await axios.get(tableUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          console.log('onBackParentID')
          var x = window.pageXOffset
          var y = window.pageYOffset
          this.corX = x
          this.corY = y
          window.scrollTo(0, 0)
          this.listView = false
          this.formView = true
          this.table = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error!!!', error.response.data.message, 'error')
          throw error
        })
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.table = {
        id: null,
        table_no: null,
        alias: null,
        notes: null,
        asset_no: null,
        asset: null,
        company_no: null,
        expenses: [{
          id: null,
          table_no: null,
          product_no: null,
          qty: '0',
          uom_id: null,
          price: '0',
          subtotal: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          notes: null,
          company_no: null
        }]
      }
    },
    onBackSaveChild () {
      this.listView = true
      this.formView = false
      this.table = {
        id: null,
        table_no: null,
        alias: null,
        notes: null,
        asset_no: null,
        asset: null,
        company_no: null,
        expenses: [{
          id: null,
          table_no: null,
          product_no: null,
          qty: '0',
          uom_id: null,
          price: '0',
          subtotal: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          notes: null,
          company_no: null
        }]
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList,
      taxList: state => state.taxes.taxList
    })
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getProductListSelect')
  }
}
</script>
